// extracted by mini-css-extract-plugin
export var desc = "VideoPageCardSection-module--desc--0e925";
export var logoPlay = "VideoPageCardSection-module--logoPlay--bb75c";
export var title = "VideoPageCardSection-module--title--31cd3";
export var videoCarte = "VideoPageCardSection-module--videoCarte--35927";
export var videoWrapper = "VideoPageCardSection-module--videoWrapper--7c7ea";